import { render, staticRenderFns } from "./UserAccountView.vue?vue&type=template&id=853b2228&"
import script from "./UserAccountView.vue?vue&type=script&lang=js&"
export * from "./UserAccountView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports